import keys from "../config/keys";

export const fetchWrapper = {
  get,
  post,
  put,
  patch,
  delete: _delete,
  // formData
};

function get(url: string) {
  const requestOptions: object = {
    method: "GET",
    // headers: authHeader(),
  };
  return fetch(`${keys}/${url}`, requestOptions).then(handleResponse);
}

function post(url: string, body: object) {
  let requestOptions: object;
  // if (url.includes("loginXXX")) {
  requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      // "access-control-request-headers": "authorization,content-type",
    },
    //credentials: 'include',
    body: JSON.stringify(body),
    mode: "cors",
  };
  // } else {
  //   requestOptions = {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //       "Access-Control-Allow-Origin": "*",
  //       // ...authHeader(),
  //     },
  //     // credentials: 'include',
  //     body: JSON.stringify(body),
  //   };
  // }
  return fetch(`${keys}/${url}`, requestOptions).then(handleResponse);
}

function put(url: string, body: object) {
  const requestOptions: object = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      // ...authHeader(),
    },
    body: JSON.stringify(body),
  };
  return fetch(`${keys}${url}`, requestOptions).then(handleResponse);
}

function patch(url: string, body: object) {
  const requestOptions: object = {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      // ...authHeader(),
    },
    body: JSON.stringify(body),
  };
  return fetch(`${keys}${url}`, requestOptions).then(handleResponse);
}

// prefixed with underscored because delete is a reserved word in javascript
function _delete(url: string) {
  const requestOptions: object = {
    method: "DELETE",
    headers: authHeader(),
  };
  return fetch(`${keys}${url}`, requestOptions).then(handleResponse);
}

// function formData(url:string,  body:any) {
//     const requestOptions:object = {
//         method: 'POST',
//         headers: { 'Access-Control-Allow-Origin': '*', ...authHeader() },
//         // credentials: 'include',
//         body: body
//     };
// return fetch(`${keys.API_URL}${url}`, requestOptions).then(handleResponse);
// }

// // helper functions

export function authHeader() {
  // const cookies = new Cookies();
  // let token = cookies.get("jwt");
  // // return authorization header with bearer auth credentials
  // // if (token) {
  // return {
  //   Authorization: "Bearer " + token,
  // };
  // } else {
  //     return {};
  // }
}

// export function logout() {
//     // remove jwt from cookies to log user out
//     const cookies = new Cookies();
//     cookies.remove("jwt");

// }

export function handleResponse(response: Response) {
  // return Promise.reject(response);

  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (
        response.status === 403 &&
        data &&
        data.message &&
        data.message.includes("Access Denied")
      ) {
        // auto logout if 403 response returned from api
        // logout();
        window.location.assign("/login");
      } else if (response.status === 701) {
        return data;
      }

      // const error = (data && data.message) || response.statusText;
      // return Promise.reject(error);
      else return response.json();
    }

    return data;
  });
}
